<div class="sticky-back">
    <section>
       <button class="right-corder-container-button">
       <span class="short-icon"><i class="fa fa-envelope"></i></span>
       <span class="short-text"><a style="margin-left:18px" href="mailto:hr@mobilise.co.in"> hr@mobilise.co.in</a></span>
       </button>
    </section>
    
    <section>
        <button class="right-corder-container-button">
        <span class="short-icon"><i class="fa fa-phone"></i></span>
        <span class="short-text"><a style="margin-left:18px" href=""> 1800 123 8798</a></span>
        </button>
     </section>
     <section>
        <button class="right-corder-container-button" (click)="showHelpModal()">
        <span class="short-icon"><i class="fa fa-comments"></i></span>
        <span class="short-text"><a style="margin-left:18px" href="">Query Helpdesk</a></span>
        </button>
     </section>
    <!-- <section>
       <button class="right-corder-container-button-none bg-danger text-white" (click)="sosDisk()">
       <span class="short-icon" style="margin-left:-3px;">sos</span>
       </button>
    </section> -->
    <!-- <section>
       <button class="right-corder-container-button-none">
       <span class="short-icon"><i class="fa fa-headphones"></i></span>
       <span class="short-text"><a style="margin-left:18px;" href=""></a></span>
       </button>
    </section> -->
 </div>
 <app-add-issue [mdlId]="modalId"></app-add-issue>

 <div
  id="feedbackMdl"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal" aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div> -->

      <div class="modal-body pt-4">
        <h1>Hello</h1>
      </div>
    </div>
  </div>
</div>








<div class="modal custom-modal fade" id="sos-help-disk" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Welcome SOS Service</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="sosForm" (ngSubmit)="submitSos()">
                    <p>Thanks! for using SOS Service. On clicking this button an sms will be sent to regional HR and A ticket will be generated. Please click on Submit to continue or cancel to reject!</p>
                    <div class="form-group">
                        <label>Mobile <span class="text-danger">*</span></label>
                        <div><input class="form-control" formControlName="sos_contact_no" placeholder="Enter Your Mobile Number" type="number"></div>
                        <div *ngIf="submit && sosErrorMsg.sos_contact_no.errors" class="form-error">
                            <div *ngIf="sosErrorMsg.sos_contact_no.errors.required">Contact Number is required !</div>
                         </div>
                    </div>
                    <div class="submit-section">
                        <button class="btn btn-primary btn-sm">Submit</button>
                        <button class="btn btn-danger btn-sm m-l-15" data-dismiss="modal" (click)="reset()">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>